import { cnva } from '@/app/utils/cnva';

export const SpartanSlidePaginationButtonStyled = cnva(
  [
    'relative -my-2 flex h-6 items-center justify-center transition-[width,margin] duration-400 ease-[cubic-bezier(0.4,0,0.2,1)] outline-none focus-visible:outline-2 focus-visible:outline-offset-2 motion-reduce:transition-none',
  ],
  {
    variants: {
      isActive: {
        true: 'pointer-events-none w-10',
        false: '-mx-2 w-6 cursor-pointer',
      },
      theme: {
        light: 'focus-visible:outline-white',
        dark: 'focus-visible:outline-gray-800',
      },
    },
    defaultVariants: {
      isActive: false,
      theme: 'light',
    },
  }
);

export const SpartanSlidePaginationTrackStyled = cnva(
  [
    'pointer-events-none absolute top-1/2 left-0 block h-2 -translate-y-1/2 overflow-hidden rounded-full transition-[width,translate] duration-400 ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none',
  ],
  {
    variants: {
      isActive: {
        true: 'w-10 translate-x-0',
        false: 'w-2 translate-x-2',
      },
      theme: {
        light: 'bg-white/30',
        dark: 'bg-gray-100',
      },
    },
    defaultVariants: {
      isActive: false,
      theme: 'light',
    },
  }
);

export const SpartanSlidePaginationProgressStyled = cnva(
  [
    'absolute inset-0 block origin-left opacity-0 transition-opacity duration-400 ease-[cubic-bezier(0.4,0,0.2,1)] will-change-transform motion-reduce:transition-none',
  ],
  {
    variants: {
      isActive: {
        true: 'opacity-100',
        false: 'opacity-0',
      },
      theme: {
        light: 'bg-white',
        dark: 'bg-gray-800',
      },
    },
    defaultVariants: {
      isActive: false,
      theme: 'light',
    },
  }
);
